import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { YesNoDialogComponent } from './yesno-dialog/yesno-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';

@NgModule({
  declarations: [YesNoDialogComponent, MessageDialogComponent],
  imports: [
      CommonModule,
      MatDialogModule,
      MatIconModule,
      MatButtonModule,
      TranslateModule ],
  exports: [YesNoDialogComponent, MessageDialogComponent]
})
export class DialogsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DialogsModule
    };
  }
}
